import React from 'react';
import PropTypes from 'prop-types';
import { LeftOutlined } from '@ant-design/icons';

import { Flex, Text } from '../components';

export function PageTitle(props) {
  const { title } = props;
  const onboardV2Link = `${ONBOARD_V2_HOST}/onboard/${window.onboardingV2Token}`;

  return (
    <Flex mb={24} pl={20} pr={42} pt={20} pb={20} ml={-20} mr={-20} style={{ borderBottom: '1px solid #02194F0D', height: '64px' }}>
      <Flex alignItems="center" width="100%">
        <LeftOutlined
          style={{ fontSize: '18px', marginRight: '16px', color: '#081A4580' }}
          onClick={() => {
            // TODO
            window.open(onboardV2Link, '_self');
          }}
        />
        <Flex flex={1} flexDirection="column" alignItems="center">
          <Text fontSize="18px" color="#2F333E" textAlign="center">
            {title}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default PageTitle;
